import dayjs from 'dayjs';
import * as Yup from 'yup';

export const endDateValidation = Yup.date()
  .required()
  .when('start', ([start], schema) => {
    if (!start) {
      return schema;
    }

    const date = dayjs(start);
    if (!date.isValid()) {
      return schema;
    }

    return schema.min(
      date.startOf('d').toDate(),
      'The end date must be equal to or greater than the start date'
    );
  });

export const formatTimestampToDateTime = (timestamp: any) => {
  const date = new Date(timestamp);
  return date.toISOString().replace('T', ' ').substring(0, 19);
};

export const expandToOneMinuteSlots = (slots: any[]) => {
  const expandedSlots: any = [];

  slots.forEach((slot) => {
    const { endTime, startTime, doctorNames } = slot;
    let current = startTime;

    while (current < endTime) {
      expandedSlots.push({
        startTime: current,
        endTime: current + 60 * 1000,
        doctorNames: doctorNames || [],
      });

      current += 60 * 1000;
    }
  });

  return expandedSlots;
};

export const mergeSlots = (
  slots: any[],
  duration: number,
  currentSlotGap: number = 10
) => {
  const mergedSlots = [];
  const availableSlots = new Map();
  const oneMinuteSlots = expandToOneMinuteSlots(slots);
  oneMinuteSlots.forEach((slot: any) => {
    availableSlots.set(slot.startTime, slot);
  });

  const baseDate = new Date();
  const startOfDayUTC = Date.UTC(
    baseDate.getUTCFullYear(),
    baseDate.getUTCMonth(),
    baseDate.getUTCDate()
  );

  let currentStartTime = startOfDayUTC;

  const slotDurationMinutes = duration;

  const maxTime = Math.max(...Array.from(availableSlots.keys()));
  while (currentStartTime <= maxTime) {
    const endTime = currentStartTime + slotDurationMinutes * 60 * 1000;

    let currentTime = currentStartTime;
    let isValid = true;
    let mergedDoctors: any[] = [];

    while (currentTime < endTime) {
      if (!availableSlots.has(currentTime)) {
        isValid = false;
        break;
      }
      const slot = availableSlots.get(currentTime);
      if (slot.doctorNames) {
        mergedDoctors = [...mergedDoctors, ...slot.doctorNames];
      }
      currentTime += currentSlotGap * 60 * 1000;
    }

    if (isValid) {
      mergedSlots.push({
        endTime: endTime,
        doctorNames: mergedDoctors,
        startTime: currentStartTime,
      });
    }

    currentStartTime = endTime;
  }

  return mergedSlots;
};
